import {useMutation} from "@apollo/client";

import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {GQL_REMOVE_SAML_SETTINGS, GQL_STATUS_PAGE_QUERY, GQL_UPDATE_SAML_SETTINGS} from "@/lib/queries/statuspages.ts";
import {MutationStatusResponse, ResponseStatus} from "@/lib/types/common.ts";
import {IDPInfo, SAMLSettings} from "@/lib/types/statuspages.ts";
import {SSOFormValues} from "@/pages/statuspages/tabs/sso/SSOSetupStep2.tsx";
import {SSOSetupV2} from "@/pages/statuspages/tabs/sso/SSOSetupV2.tsx";

interface SSOTabProps {
  statusPageID: number;
  samlSettings: SAMLSettings;
  testIDPs: IDPInfo[];
}

export const SSOTab = ({statusPageID, samlSettings, testIDPs}: SSOTabProps) => {
  const [updateSAMLSettings] = useMutation<MutationStatusResponse>(GQL_UPDATE_SAML_SETTINGS, {
    refetchQueries: [GQL_STATUS_PAGE_QUERY],
  });
  const [removeSAMLSettings] = useMutation<MutationStatusResponse>(GQL_REMOVE_SAML_SETTINGS, {
    refetchQueries: [GQL_STATUS_PAGE_QUERY],
  });
  const updateSAML = async (data: SSOFormValues) => {
    const response = await updateSAMLSettings({
      variables: {
        statusPageID: statusPageID,
        data: data,
      },
    });
    return response.data?.response;
  };
  const removeSAML = async () => {
    const response = await removeSAMLSettings({
      variables: {
        statusPageID: statusPageID,
      },
    });
    return response.data?.response.status === ResponseStatus.SUCCESS;
  };

  const metadataURL = `${URL_ORIGINAL_WEBSITE}/statuspages/${statusPageID}/sso/saml/metadata`;

  return (
    <SSOSetupV2
      metadataURL={metadataURL}
      samlSettings={samlSettings}
      testIDPs={testIDPs}
      updateSAML={updateSAML}
      removeSAML={removeSAML}
    />
  );
};
